import { AlertTriangle, Construction } from "lucide-react";

export function NexusReformBanner() {
  return (
    <section
      aria-label="Nexus platform reform notice"
      className="relative isolate overflow-hidden border-b border-amber/50 bg-amber/15 px-3 py-3 text-foreground sm:px-5 sm:py-4"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 w-1 bg-amber" />
      <div className="mx-auto flex max-w-7xl items-start gap-3 sm:items-center">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-amber/50 bg-background/60 text-amber">
          <Construction className="h-5 w-5" aria-hidden="true" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-amber">
            Major platform reform underway
          </p>
          <p className="mt-0.5 font-display text-base font-semibold sm:text-lg">
            Nexus is being rebuilt and will soon be completely new.
          </p>
          <p className="mt-1 max-w-4xl text-xs leading-relaxed text-muted-foreground sm:text-sm">
            Current tools remain available during the transition, but workflows, coverage, results and saved report formats may change.
          </p>
        </div>
      </div>
    </section>
  );
}

export function NexusReformDisclaimer() {
  return (
    <section
      role="alert"
      aria-labelledby="nexus-reform-heading"
      className="relative overflow-hidden rounded-md border border-amber/50 bg-amber/10 p-4 sm:p-5"
    >
      <div className="absolute inset-y-0 left-0 w-1 bg-amber" />
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber" aria-hidden="true" />
        <div className="min-w-0">
          <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-amber">
            Reform-period disclaimer
          </p>
          <h2 id="nexus-reform-heading" className="mt-1 font-display text-xl font-semibold sm:text-2xl">
            This is the current Nexus, not the final rebuilt platform.
          </h2>
          <p className="mt-2 max-w-4xl text-sm leading-relaxed text-muted-foreground">
            Nexus is undergoing a complete architecture and investigation-workflow overhaul. Features may be replaced, moved or temporarily limited. Treat all current outputs as preliminary research leads: verify every claim against its cited original source before making operational, legal, financial or safety decisions.
          </p>
        </div>
      </div>
    </section>
  );
}

export function NexusResultDisclaimer() {
  return (
    <div className="flex items-start gap-2 rounded-md border border-panel-border bg-background/50 px-3 py-2 text-xs leading-relaxed text-muted-foreground">
      <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber" aria-hidden="true" />
      <p>
        <strong className="font-medium text-foreground">Transitional output:</strong> source availability and analysis may change during the Nexus rebuild. Results are investigative leads, not verified facts or professional advice.
      </p>
    </div>
  );
}